

const firebaseConfig = {
    apiKey: "AIzaSyB4YI64mQcwqurs26YVKGKPqCf_NfXvyoA",
    authDomain: "health-care-services-23.firebaseapp.com",
    projectId: "health-care-services-23",
    storageBucket: "health-care-services-23.appspot.com",
    messagingSenderId: "817714237763",
    appId: "1:817714237763:web:39e0444946f547b9c6dff6",
    measurementId: "G-DS5LLT6BCQ"
  };
  export default firebaseConfig;